import { createSelector } from 'reselect';
import { AppState } from '../store/types/Store';
import { PlantingLocaleGroup, PlantingEvent } from '../types';
import { getCurrentSeason } from './seasonSelectors';
import { getArdDataFeatureSelector } from './featureSelectors';
import { getSeasonTagWithWildcards, isSeasonTagWithWildcards } from '../utils/seasonUtils';

export const getPlanting = (state: AppState) => state.planting;

export const getCurrentPlantingData = createSelector([
  getArdDataFeatureSelector,
  getPlanting,
  getCurrentSeason
], (isPlantingArdDataEnabled, planting, currentSeason) => {
  let adaptedSeasonTag = currentSeason;
  if (isPlantingArdDataEnabled && !isSeasonTagWithWildcards(currentSeason)) {
    adaptedSeasonTag = getSeasonTagWithWildcards(adaptedSeasonTag);
  }

  // TODO: Remove assertion after LI-889
  return planting[adaptedSeasonTag] as PlantingEvent | undefined
}
  
);

export const getPopulationFromPlantingData = createSelector(
  [getCurrentPlantingData],
  (plantingData) => plantingData && plantingData.population
);

export const isAirSeederPopulation = createSelector(
  [getPopulationFromPlantingData],
  (plantingPopulation) =>
    plantingPopulation?.localeGroup === PlantingLocaleGroup.POPULATION_WEIGHT
);
